import { Directive, Input, OnInit, ViewChild } from '@angular/core';
import { getTransmissionMethodLabel } from 'src/app/_enums/cancellation/transmission-method.enum';
import { getInsuranceTypeLabel } from 'src/app/_enums/insurance-type.enum';
import { UserAuthService } from 'src/app/_services/user-auth.service';
import { CancellationMetadata } from 'src/app/_types/lead.types';
import { ProposalDetails } from 'src/app/_types/proposals.type';

import { PdfViewerModalComponent } from '../../../pdf-viewer-modal/pdf-viewer-modal.component';
import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class CancellationMetadataComponentAbstract
  extends BaseMetadataComponent<CancellationMetadata>
  implements OnInit
{
  policyLink!: string;

  proposalDetails!: ProposalDetails;

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.metadata.policyProposalId) {
      this.userAuthService
        .GetProposalDetail({
          proposalId: this.metadata.policyProposalId,
        })
        .subscribe({
          next: (x: any) => {
            this.proposalDetails = x.data;
            this.policyLink = `/proposal/view/${this.proposalDetails.proposalId}`;
          },
        });
    }
  }

  getInsuranceTypeLabel = getInsuranceTypeLabel;

  getTransmissionMethodLabel = getTransmissionMethodLabel;

  @ViewChild('pdfViewer') viewer!: PdfViewerModalComponent;

  viewFile(key: string) {
    this.userAuthService.getPresignedUrl(key).subscribe((res) => {
      if (res.status === 'SUCCESS') {
        this.viewer.pdfFileUrl = res.data.preSignedUrl;
        this.viewer.openModal();
      }
    });
  }
}
